import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { FiTarget, FiUsers, FiAward } from 'react-icons/fi'

import { Context } from '../../context/UserContext'
import planetHero from '../../assets/planet-hero.jpg'
import moonFull from '../../assets/moons/moon-full.jpg'
import moonEuropa from '../../assets/moons/moon-europa.jpg'

import './Home.css'

function Home() {
    const { authenticated } = useContext(Context)

    return (
        <div className="home">
            {/* fundo fixo: cobre a página inteira (herói + cards abaixo), sem
                corte entre as seções — estrelas, planeta e luas continuam
                visíveis atrás de tudo ao rolar a página */}
            <div className="home-bg" aria-hidden="true">
                <div className="home-stars home-stars-a" />
                <div className="home-stars home-stars-b" />

                <div className="home-hero-art">
                    <img src={planetHero} alt="" className="home-hero-planet-img" />
                    <div className="home-hero-planet-tint" />
                    <div className="hud-ring hud-ring-outer" />
                    <div className="hud-ring hud-ring-inner" />
                </div>

                <div className="moon moon-1">
                    <img src={moonFull} alt="" className="moon-img" />
                    <div className="moon-tint" />
                </div>
                <div className="moon moon-3">
                    <img src={moonEuropa} alt="" className="moon-img" />
                    <div className="moon-tint" />
                </div>

                <div className="hud-scan" />

                <div className="hud-frame">
                    <span className="hud-corner hud-corner-tl" />
                    <span className="hud-corner hud-corner-tr" />
                    <span className="hud-corner hud-corner-bl" />
                    <span className="hud-corner hud-corner-br" />

                    <div className="hud-readout hud-readout-tl">
                        <span className="hud-dot" />
                        VARREDURA 98%
                    </div>
                    <div className="hud-readout hud-readout-br">
                        <span className="hud-dot" />
                        SETOR 07 · ONLINE
                    </div>
                </div>
            </div>

            <section className="home-hero">
                <div className="home-hero-content">
                    <p className="home-hero-eyebrow">Laser tag</p>
                    <h1 className="home-hero-title">
                        PLANETA <span>ARENA</span>
                    </h1>
                    <p className="home-hero-subtitle">
                        Entre na arena, dispute cada partida e suba no ranking dos melhores jogadores.
                    </p>

                    {authenticated ? (
                        <div className="home-hero-actions">
                            <Link to="/perfil" className="btn-primary">Ver meu perfil</Link>
                            <Link to="/ranking" className="home-hero-secondary">Ver ranking</Link>
                        </div>
                    ) : (
                        <div className="home-hero-actions">
                            <Link to="/cadastro" className="btn-primary">Criar conta</Link>
                            <Link to="/login" className="home-hero-secondary">Já tenho conta</Link>
                        </div>
                    )}
                </div>
            </section>

            <section className="home-features">
                <div className="home-feature panel">
                    <FiTarget size={28} />
                    <h3>Partidas</h3>
                    <p>Cada sessão no espaço físico conta pontos pra sua evolução na arena.</p>
                </div>
                <div className="home-feature panel">
                    <FiAward size={28} />
                    <h3>Ranking</h3>
                    <p>Acompanhe sua posição frente aos outros jogadores em tempo real.</p>
                </div>
                <div className="home-feature panel">
                    <FiUsers size={28} />
                    <h3>Perfil</h3>
                    <p>Gerencie seus dados e acompanhe sua trajetória dentro da arena.</p>
                </div>
            </section>
        </div>
    )
}

export default Home
